module.exports = __webpack_public_path__ + "img/12.84a71e9e.png";